// extracted by mini-css-extract-plugin
export default {"action":"Notifications_action__GL+h9","items":"Notifications_items__yazvU","contentWrapper":"Notifications_contentWrapper__ZJV8z"};